import { toggle } from "./toggle";

export default toggle("dependents-enabled");
